import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { ocrAadhar } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Data6 } from "../Data";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";


const OcrAadhar = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [aadharData, setAadharData] = useState([]);
    const [showAadharData, setShowAadharData] = useState(false)
    const [errors, setErrors] = useState({});
    const [profileData, setProfileData] = useState({});
    const [aadhar, setAadhar] = useState("");
    const { serviceName } = useService();
    const [ocrAadharFile, setOcrAadharFile] = useState(null);


    // Fetch profile data on mount
    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setIsLoading(true);
                const response = await fetchProfile();
                setProfileData(response.data);
            } catch (error) {
                console.error("Error fetching profile data:", error);
                showErrorToast("Failed to fetch profile data.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfileData();
    }, []);

    const validateForm = (ocrAadharFile) => {
        const errors = {};

        if (!ocrAadharFile) {
            errors.ocrAadharFile = "Aadhar PDF is required.";
        } else {
            const allowedTypes = [
                "application/pdf",
                "image/jpeg",
                "image/jpg",
                "image/png"
            ];

            if (!allowedTypes.includes(ocrAadharFile.type)) {
                errors.ocrAadharFile = "Only PDF, JPG, or PNG files are allowed.";
            }
        }
        return errors;
    };

    const handleSubmit = async () => {


        const validationErrors = validateForm(ocrAadharFile);
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length > 0) return;


        try {
            setIsLoading(true);

            const formData = new FormData();
            formData.append("api_id", profileData?.user_id);
            formData.append("api_key", profileData?.api_key);
            formData.append("token_id", profileData?.token_id);
            formData.append("pdf", ocrAadharFile);

            const response = await ocrAadhar(formData);

            const statusCode = response?.status?.code || response?.status;

            if (statusCode === 200) {

                const rcData = response?.data;  

                if (rcData) {
                    setAadharData(rcData); 
                    setShowAadharData(true);
                    showSuccessToast(response.message, "Aadhar Details fetched successfully.");
                    setAadhar("");
                    setErrors({});
                } else {
                    showErrorToast("Unexpected API format.");
                }
            }


            else if (statusCode === 422) {
                showErrorToast(response.data.message || "Invalid format");
            }

            else if (statusCode === 500) {
                showErrorToast(response.data.message || "Server error");
            }

            else {
                showErrorToast(response.status?.message || "Something went wrong");
            }

        } catch (error) {
            console.error("Aadhar Error:", error);
            showErrorToast("Failed to verify Aadhar Father Details.");
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <>
            <Seo />
            {isLoading && <Loader />}
            <Header heading={serviceName} />

            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 justify-center md:ml-80 ml-0 p-4">

                <div className="col-span-2 md:col-span-6 flex justify-end">
                    <Link
                        to="/TestMaster"
                        className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
                    >
                        <span>Go Back</span>
                        <IoArrowBackCircleOutline size={24} />
                    </Link>
                </div>

                <InputWithLabel
                    type="file"
                    label="OCR Aadhar"
                    placeholder="Upload Aadhar PDF"
                    className="p-1 rounded shadow-lg cursor-pointer shadow-blue-500/50 border border-blue-600"
                    name="ocr_Aadhar"
                    id="ocr_Aadhar"
                    required={true}
                    accept="application/pdf" 
                    onChange={(e) => setOcrAadharFile(e.target.files[0])}
                    error={errors.ocrAadharFile}
                />


                <div>
                    <Button
                        type="button"
                        className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
                        id="verifyMob"
                        name="verifyMob"
                        text="Verify"
                        onClick={handleSubmit}
                    />
                </div>
            </div>
            {aadharData && aadharData.length > 0 && (
                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4 my-4 ">

                 <div className="bg-white border border-yellow-300 rounded-md shadow-lg p-4 overflow-auto max-h-110">
                        <h2 className="text-lg font-semibold text-yellow-800 mb-3">Raw Response (JSON)</h2>
                        <pre className="text-sm bg-gray-100 p-2 rounded-md">{JSON.stringify(aadharData, null, 2)}</pre>
                    </div>
                 <div className="bg-white border border-green-300 rounded-md shadow-lg p-4">
                    <h3 className="font-semibold mb-4">Aadhaar Details</h3>

                    {/* Front Details */}
                    <div className="mb-6 p-4 border rounded bg-gray-50">
                        <h4 className="font-semibold mb-2">Front Details</h4>
                        <p><strong>Name:</strong> {aadharData[0]?.details?.name?.value || "-"}</p>
                        <p><strong>Father:</strong> {aadharData[0]?.details?.father?.value || "-"}</p>
                        <p><strong>Mother:</strong> {aadharData[0]?.details?.mother?.value || "-"}</p>
                        <p><strong>Husband:</strong> {aadharData[0]?.details?.husband?.value || "-"}</p>
                        <p><strong>DOB:</strong> {aadharData[0]?.details?.dob?.value || "-"}</p>
                        <p><strong>Gender:</strong> {aadharData[0]?.details?.gender?.value || "-"}</p>
                        <p><strong>YOB:</strong> {aadharData[0]?.details?.yob?.value || "-"}</p>
                        <p><strong>Phone:</strong> {aadharData[0]?.details?.phone?.value || "-"}</p>
                        <p><strong>Aadhaar No:</strong> {aadharData[0]?.details?.aadhaar?.value || "-"}</p>
                        <p><strong>Is Masked:</strong> {aadharData[0]?.details?.aadhaar?.ismasked || "-"}</p>
                        <p><strong>Verhoeff Check Passed:</strong> {aadharData[0]?.details?.aadhaar?.verhoeffCheckPassed || "-"}</p>
                        <p><strong>VID:</strong> {aadharData[0]?.details?.vid?.value || "-"}</p>
                        <p><strong>QR Code:</strong> {aadharData[0]?.details?.qr?.value || "-"}</p>
                        <p><strong>Barcode:</strong> {aadharData[0]?.details?.barcode?.value || "-"}</p>
                    </div>

                    {/* Back Details */}
                    <div className="mb-6 p-4 border rounded bg-gray-50">
                        <h4 className="font-semibold mb-2">Back Details</h4>
                        <p><strong>Father:</strong> {aadharData[1]?.details?.father?.value || "-"}</p>
                        <p><strong>Husband:</strong> {aadharData[1]?.details?.husband?.value || "-"}</p>
                        <p><strong>PIN:</strong> {aadharData[1]?.details?.pin?.value || "-"}</p>
                        <p><strong>Care Of:</strong> {aadharData[1]?.details?.care_of?.value || "-"}</p>
                        <p><strong>Aadhaar No:</strong> {aadharData[1]?.details?.aadhaar?.value || "-"}</p>
                        <p><strong>VID:</strong> {aadharData[1]?.details?.vid?.value || "-"}</p>
                        <p><strong>Address:</strong> {aadharData[1]?.details?.address?.value || "-"}</p>

                        {aadharData[1]?.details?.address && (
                            <>
                                <p><strong>House Number:</strong> {aadharData[1]?.details?.address?.house_number || "-"}</p>
                                <p><strong>Street:</strong> {aadharData[1]?.details?.address?.street || "-"}</p>
                                <p><strong>Locality:</strong> {aadharData[1]?.details?.address?.locality || "-"}</p>
                                <p><strong>Landmark:</strong> {aadharData[1]?.details?.address?.landmark || "-"}</p>
                                <p><strong>City:</strong> {aadharData[1]?.details?.address?.city || "-"}</p>
                                <p><strong>District:</strong> {aadharData[1]?.details?.address?.district || "-"}</p>
                                <p><strong>State:</strong> {aadharData[1]?.details?.address?.state || "-"}</p>
                            </>
                        )}

                        <p><strong>QR Code:</strong> {aadharData[1]?.details?.qr?.value || "-"}</p>
                        <p><strong>Barcode:</strong> {aadharData[1]?.details?.barcode?.value || "-"}</p>
                    </div>
                </div>
                </div>
            )}

        </>
    );
};

export default OcrAadhar;
